/* eslint-disable react/prop-types */
import { Checkbox, FormControlLabel, Select, Stack, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import SoftBox from "../../components/SoftBox";
import SoftInput from "../../components/SoftInput";
import SoftTypography from "../../components/SoftTypography";
import SoftButton from "components/SoftButton";
import queryString from "utils/queryString";
import { toast } from "react-toastify";
import { useState } from "react";
import React from "react";
import { getGhollaks } from "services/ghollak.routes";
import { getInvestmentOpportunity } from "services/investmentOpportunity.routes";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import moment from "jalali-moment";

export default function TableHeadItems({ filterInfo, onClearFilterClick, handleFilterChange, onFilterClick, setFilterInfo }) {
    const [ghollakResults, setGhollakResults] = useState([]);
    const [investmentResults, setInvestmentResults] = useState([]);
    const [searchInfo, setSearchInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const [selectedDay, setSelectedDay] = useState({
        from: null,
        to: null,
    });
    const handleChange = (event) => {
        const { name, value } = event.target;
        setSearchInfo({ ...searchInfo, [name]: value });
    };

    const searchGhollaks = () => {
        if (searchInfo.ghollakName) {
            setLoading(true);
            let query = {
                admin: 1,
                name: searchInfo.ghollakName,
                all: 1,
                per_page: 30,
            };

            getGhollaks(queryString(query), true, (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    return toast.error(data.message);
                } else {
                    setGhollakResults(data.data);
                }
            });
        }
    };
    const searchInvestment = () => {
        if (searchInfo.IOName) {
            setLoading(true);
            let query = {
                name: searchInfo.IOName,
                per_page: 30,
            };

            getInvestmentOpportunity(queryString(query), true, (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    return toast.error(data.message);
                } else {
                    setInvestmentResults(data.data);
                }
            });
        }
    };
    const renderCustomInput = ({ ref }) => (
        <input
            readOnly
            ref={ref}
            value={(selectedDay.from && selectedDay.to) ? `${selectedDay?.from?.year}/${selectedDay?.from?.month}/${selectedDay?.from?.day} - ${selectedDay?.to?.year}/${selectedDay?.to?.month}/${selectedDay?.to?.day}` : ""}
            style={{
                background: 'white',
                padding: '8px 12px',
                width: '100%',
                border: '0.0625rem solid #d2d6da',
                borderRadius: '0.5rem',
                height: '39px',
                color: '#495057'
            }}
        />
    );
    const onSelectedDate = (value) => {
        const formatedDateTo = (value.to) ? `${value?.to?.year}/${value?.to?.month}/${value?.to?.day}` : null
        const formatedDateFrom = (value.from) ? `${value?.from?.year}/${value?.from?.month}/${value?.from?.day}` : null
        setSelectedDay(value)
        setFilterInfo({
            ...filterInfo,
            to_for_date: formatedDateTo ? moment(formatedDateTo, 'jYYYY/jM/jD').format('YYYY-M-D') : null,
            from_for_date: formatedDateFrom ? moment(formatedDateFrom, 'jYYYY/jM/jD').format('YYYY-M-D') : null,
        });
    }
    return (
        <Grid container gap={2} mb={2}>
            <Grid item xs={12} md={6} lg={2}>
                <SoftBox mb={1} ml={0.5}>
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                        قلک
                    </SoftTypography>
                </SoftBox>
                <SoftInput
                    placeholder="نام قلک"
                    value={searchInfo?.ghollakName}
                    name="ghollakName"
                    onChange={handleChange}
                    type="text"
                    endAdornment={
                        <SoftButton
                            onClick={searchGhollaks}
                            size="small"
                            style={{ position: "absolute", left: '-1rem' }}
                            variant="text"
                            disabled={loading}
                            color="info"
                        >
                            {loading ? "..." : "🔍"}
                        </SoftButton>
                    }
                />
                {ghollakResults.length > 0 && <section>
                    <p style={{ fontSize: 12, marginTop: 10 }}>قلک ها</p>
                    <Select
                        name="ghollak_id"
                        defaultOpen
                        value={String(filterInfo?.ghollak_id)}
                        onChange={handleFilterChange}
                        fullWidth
                    >
                        <MenuItem value="">
                            <em>هیچکدام</em>
                        </MenuItem>
                        {ghollakResults.map(item => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                </section>}
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
                <SoftBox mb={1} ml={0.5}>
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                        فرصت
                    </SoftTypography>
                </SoftBox>
                <SoftInput
                    placeholder="نام فرصت"
                    value={searchInfo?.IOName}
                    name="IOName"
                    onChange={handleChange}
                    type="text"
                    endAdornment={
                        <SoftButton
                            onClick={searchInvestment}
                            size="small"
                            style={{ position: "absolute", left: '-1rem' }}
                            variant="text"
                            disabled={loading}
                            color="info"
                        >
                            {loading ? "..." : "🔍"}
                        </SoftButton>
                    }
                />
                {investmentResults.length > 0 && <section>
                    <p style={{ fontSize: 12, marginTop: 10 }}>فرصت ها</p>
                    <Select
                        name="investment_opportunity_id"
                        defaultOpen
                        value={String(filterInfo?.investment_opportunity_id)}
                        onChange={handleFilterChange}
                        fullWidth
                    >
                        <MenuItem value="">
                            <em>هیچکدام</em>
                        </MenuItem>
                        {investmentResults.map(item => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                </section>}
            </Grid>
            <Grid item xs={12} sm={6} xl={2}>
                <SoftBox mb={1} ml={0.5}>
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                        تاریخ
                    </SoftTypography>
                </SoftBox>
                <DatePicker
                    value={selectedDay}
                    onChange={onSelectedDate}
                    renderInput={renderCustomInput}
                    selectorStartingYear={Number(moment()?.locale("fa")?.format("YYYY"))}
                    selectorEndingYear={Number(moment()?.locale("fa")?.format("YYYY")) + 1}
                    shouldHighlightWeekends
                    wrapperClassName="w-full"
                    locale="fa"
                    colorPrimary="#0fbcf9"
                    colorPrimaryLight="rgba(75, 207, 250, 0.4)"
                />
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
                <SoftButton
                    onClick={onFilterClick}
                    size="small"
                    style={{ marginTop: 40, width: 100 }}
                    variant="gradient"
                    color="info"
                >
                    فیلتر
                </SoftButton>
                <SoftButton
                    onClick={() => {
                        setGhollakResults([]);
                        setSearchInfo({});
                        setInvestmentResults([]);
                        onClearFilterClick();
                    }}
                    size="small"
                    style={{ marginTop: 40, marginRight: 10, width: 44 }}
                    variant="outlined"
                    color="error"
                >
                    حذف
                </SoftButton>
            </Grid>
        </Grid>
    );
}
